// extracted by mini-css-extract-plugin
export var filterIncDec = "_bq-0";
export var leftBorder = "_bq-1";
export var rightBorder = "_bq-2";
export var stringInput = "_bq-3";